<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2" id="emails-top">Email Templates</h2>
        <p>Create, update and delete e-mail templates.</p>
      </v-flex>
      <v-flex xs12 class="mb-3">
         <v-btn
          class="ml-0 mb-3 mt-0" color="secondary"
          v-show="addTemplateButton"
          @click="addTemplateForm = true; addTemplateButton = false">
          Add a template
        </v-btn>
        <form v-show="addTemplateForm">
          <v-layout wrap row class="pa-4 mb-3" style="background:rgb(240, 240, 240);">
            <v-flex xs12 sm6 mt-2>
              <v-text-field label="Template name" v-model="newEmailName" class="white-box-field" box></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn
                class="ml-0 mr-0"
                color="success"
                :disabled="newEmailName === ''"
                v-on:click="createEmail()">
                Save &amp; Compose
              </v-btn>
              <v-btn
                color="error"
                v-on:click="addTemplateForm = false; addTemplateButton = true; newEmailName = ''">
                Cancel
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
        <v-layout
          mt-0 row wrap fluid
          class="script-card-container card-margin-fix" >
          <EmailCard
            class="mr-0"
            v-for="(email) in emailTemplates" :key="email.id"
            :email="email"
            v-on:removeEmail="remove(email)">
          </EmailCard>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import EmailCard from "@/components/cases/case-config/EmailCard.vue"

export default {
  name: "case-config-emails",
  components: { EmailCard },
  props: { caseType: { type: Object, required: true } },
  data() {
    return {
      newEmailName: "",
      addTemplateForm: false,
      addTemplateButton: true
    }
  },
  computed: {
    emailTemplates() {
      return this.caseType.emailTemplates
    }
  },
  methods: {
    async createEmail() {
      await this.$store.dispatch("createEmailTemplate", { caseTypeId: this.caseType.id, name: this.newEmailName, template: "", emailBodyTemplate: false, templateWrapperId: undefined })
      this.$store.dispatch('setupCaseType', parseInt(this.caseType.id))
      this.newEmailName = ""
      this.addTemplateForm = false
      this.addTemplateButton = true
    },
    async remove(email) {
      await this.$store.dispatch("deleteEmailTemplate", { emailTemplateId: email.id, caseTypeId: this.caseType.id })
    }
  }
}
</script>
